import React from "react";
import LoginPage from "../Components/login";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const Login = () => {
  return (
    <div>
      <Navbar />
      <LoginPage />
      <Footer />
    </div>
  );
};

export default Login;
